import styled from 'styled-components';

export const Container = styled.div`
  .react-datepicker-popper {
    width: max-content;
  }
`;
